export default __webpack_public_path__ + "static/media/testimony1.849d9f31.png";